var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_615_19664",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_615_19664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13.0499L6.9249 18.1249C6.79157 18.2582 6.6209 18.3289 6.4129 18.3369C6.20424 18.3456 6.0249 18.2749 5.8749 18.1249C5.7249 17.9749 5.6499 17.7999 5.6499 17.5999C5.6499 17.3999 5.7249 17.2249 5.8749 17.0749L10.9499 11.9999L5.8749 6.9249C5.74157 6.79157 5.6709 6.62057 5.6629 6.4119C5.65424 6.2039 5.7249 6.0249 5.8749 5.8749C6.0249 5.7249 6.1999 5.6499 6.3999 5.6499C6.5999 5.6499 6.7749 5.7249 6.9249 5.8749L11.9999 10.9499L17.0749 5.8749C17.2082 5.74157 17.3792 5.67057 17.5879 5.6619C17.7959 5.6539 17.9749 5.7249 18.1249 5.8749C18.2749 6.0249 18.3499 6.1999 18.3499 6.3999C18.3499 6.5999 18.2749 6.7749 18.1249 6.9249L13.0499 11.9999L18.1249 17.0749C18.2582 17.2082 18.3289 17.3789 18.3369 17.5869C18.3456 17.7956 18.2749 17.9749 18.1249 18.1249C17.9749 18.2749 17.7999 18.3499 17.5999 18.3499C17.3999 18.3499 17.2249 18.2749 17.0749 18.1249L11.9999 13.0499Z",
    fill: "#FE6666"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close-red.b83679349d1d8ba9a11a27a1317b7491.svg";
export { ForwardRef as ReactComponent };